import React from 'react';
import { Button, Modal } from 'antd';
import { connect } from 'dva';
import BaseComponent from './BaseComponent';
//import Dimio from './Dimio';
//import Request from 'superagent';
import _ from 'lodash';

class DimioModal extends BaseComponent {
  constructor(props) {
    super(props);
    this.onCancel = this.onCancel.bind(this);
  }

  componentWillMount() {
    const {id} = this.props;
    if(!id){
      throw new Error('Modal ID is not set');
    }

    this.regModal(id);
  }

  onCancel() {
    this.hideModal(this.props.id);
  }


  render() {
    const {id, state, title, showFooter} = this.props;
    const {modals} = state;

    const index = _.findIndex(modals, { key: id });
    if(index < 0){
      console.warn(`Modal [${id}] is not set`);
      return null;
    }

    const selected = modals[index];
    if(selected.visible == false){
      return null;
    }

    return (
      <Modal
//        {...this.props}
        visible={selected.visible}
        title={(title)?title:null}
        onCancel={this.onCancel}
        footer={
          showFooter?<Button className="btn btn-secondary btn-xs btn-block" onClick={this.onCancel}>閉じる</Button>:null
        }
      >
        {this.props.children}
      </Modal>
    )
  }
}

//export default DimioModal;

function mapStateToProps(state, ownProps) {
  const {appKey} = ownProps;
//  console.info(state.about);
//  console.info(appKey, state[appKey]);
  return {
    state: state[appKey]
  };
}
export default connect(mapStateToProps)(DimioModal);

/*
export default connect(({about}) => ({
  about
}))(DimioModal);
*/

/*
export default connect(({ meta }) => ({
  meta
}))(DimioModal);
*/





// WEBPACK FOOTER //
// ./src/components/DimioModal.js